import React, { ComponentPropsWithRef } from 'react'
import { useTranslation } from '../i18n/useTranslation'
import { useCommonCtx } from '../context/useCommonCtx'
import { MTypo } from '../components/MTypo/MTypo'
import { Button } from '@mui/material'

interface Props extends ComponentPropsWithRef<'div'> {
    onQuit: () => void
}
export const Thanks360 = (p: Props) => {
    const t = useTranslation(useCommonCtx())
    return (
        <div className="flex flex-1 flex-col justify-evenly items-center">
            <MTypo variant="h4" className="text-center">
                {t('hint_thanks')}
            </MTypo>

            <Button variant="outlined" onClick={p.onQuit}>
                <MTypo variant="h5" className="text-center">
                    {t('btn_quit')}
                </MTypo>
            </Button>
        </div>
    )
}
